module.exports = __webpack_public_path__ + "img/configuration_code.07e9f867.svg";